<template>
  <v-card>
    <v-toolbar
      color="indigo"
      dark>

      <v-toolbar-title>
        <v-icon left>{{ chartIcon }}</v-icon>
        {{ $vuetify.lang.t('$vuetify.charts.criticalEventsDistribution') }}
      </v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-skeleton-loader :loading="!loaded" type="card">
        <v-row justify="start" align-content="start" align="start">
          <v-col v-for="entry in states" :key="entry.value" md="3" cols="6">
            <v-switch v-model="statesValues[entry.value]" class="shrink my-auto" :label="entry.text"
                      :prepend-icon="entry.icon"></v-switch>
          </v-col>
        </v-row>
        <line-chart v-if="loaded" :chart-data="localizedData" :y-label="$vuetify.lang.t('$vuetify.charts.axis.count')" :x-label="$vuetify.lang.t('$vuetify.charts.axis.date')"></line-chart>
      </v-skeleton-loader>
    </v-card-text>
  </v-card>
</template>

<script>
import LineChart from './LineChart'
import Vuetify from '../../plugins/vuetify'
import backend from '../../backend'
import snackbarMixin from '../../mixins/snackbarMixin'
import {
  mdiCameraOff,
  mdiCarBrakeAlert,
  mdiCellphone,
  mdiChartLine,
  mdiFood,
  mdiSeatbelt,
  mdiSleep,
  mdiSmoking
} from '@mdi/js'

import { createHelpers } from 'vuex-map-fields'
import { SETTINGS_MODULE } from '../../store/modules'

const { mapFields: settingsFields } = createHelpers({
  getterType: `${SETTINGS_MODULE}/getField`
})

const states = () => {
  return [
    {
      text: Vuetify.framework.lang.t('$vuetify.map.managerMap.headers.distraction'),
      value: 'distraction_count',
      icon: mdiCarBrakeAlert
    },
    {
      text: Vuetify.framework.lang.t('$vuetify.map.managerMap.headers.drowsiness'),
      value: 'drowsiness_count',
      icon: mdiSleep
    },
    {
      text: Vuetify.framework.lang.t('$vuetify.map.managerMap.headers.nobelt'),
      value: 'nobelt_count',
      icon: mdiSeatbelt
    },
    {
      text: Vuetify.framework.lang.t('$vuetify.map.managerMap.headers.cameraSabotage'),
      value: 'camera_sabotage',
      icon: mdiCameraOff
    },
    {
      text: Vuetify.framework.lang.t('$vuetify.map.managerMap.headers.cellphoneUse'),
      value: 'cellphone_use',
      icon: mdiCellphone
    },
    {
      text: Vuetify.framework.lang.t('$vuetify.map.managerMap.headers.eatingCount'),
      value: 'eating_count',
      icon: mdiFood
    },
    {
      text: Vuetify.framework.lang.t('$vuetify.map.managerMap.headers.smokingCount'),
      value: 'smoking_count',
      icon: mdiSmoking
    }
  ]
}

const defaultStateValues = () => {
  const values = {}
  for (const entry of states()) {
    values[entry.value] = true
  }
  return values
}

export default {
  name: 'CriticalEventsDistirbution',
  components: { LineChart },
  mixins: [snackbarMixin],
  props: {
    filters: Object
  },
  data: () => ({
    data: [],
    labels: [],
    statesValues: defaultStateValues(),
    loaded: false,
    chartIcon: mdiChartLine
  }),
  computed: {
    ...settingsFields(['appLanguage']),
    states () {
      return states()
    },
    localizedData () {
      // const labels = // this.labels.map(month => Vuetify.framework.lang.t(`$vuetify.charts.months.${month}`))
      const datasets = this.data.datasets.map(item => ({
        ...item,
        label: states().find(k => item.label === k.value).text
      }))

      return { labels: this.labels.map(item => new Date(item)), datasets }
    }
  },
  methods: {
    async loadData () {
      this.loaded = false
      try {
        const chartResponse = await backend.loadCriticalEventsChart({
          states: Object.keys(this.statesValues).filter(item => this.statesValues[item]),
          ...this.filters
        })

        this.labels = chartResponse.data.labels // chartResponse.data.labels.map(item => new Date(item))
        this.data = chartResponse.data
      } catch (e) {
        this.processFailedRequest(e)
      } finally {
        this.loaded = true
      }
    }
  },
  async created () {
    await this.loadData()
  },
  watch: {
    statesValues: {
      async handler () {
        await this.loadData()
      },
      deep: true
    },
    async filters (value) {
      await this.loadData()
    }
  }
}
</script>

<style scoped>

</style>
